export default __webpack_public_path__ + "static/media/annotation-marked-up.717ee80a.png";